module.exports = __webpack_public_path__ + "static/media/best-class.459e6085.png";